import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import { Ptag } from "components/core";
import { 
  HeaderRow,
  HeaderRowClaimMIS,
  MaterialTable,
  MaterialTableNotFixed,
  MaterialTableContainer,
} from "components/core/BaseTable/styles";
import employeeMisTableBg from "../../assets/svgs2026/benefitsBackgroundSvg.2e98e7b1.svg";

function ProTable({ headers, rows, fixedHeader = false }) {
  return (
    <TableContainer sx={{
      ...MaterialTableContainer,
      height: "auto",
      width: "100%",
      maxWidth: "100%",
      overflowX: "auto",
      overflowY: "visible",
      position: "relative", // Crucial: Anchors the absolute-positioned text to the viewport container
      /* Hide scrollbars cross-browser */
      msOverflowStyle: "none", /* IE & Edge */
      scrollbarWidth: "none",  /* Firefox */
      "&::-webkit-scrollbar": {
        display: "none",       /* Chrome, Safari, Opera */
        width: 0,
        height: 0,
      },
    }}>
      <Table sx={{ ...MaterialTableNotFixed, width: "100%", maxWidth: "100%" }}>
        {headers && headers.length > 0 && (
          <TableHead
            style={{
              backgroundColor: "#25183e",
              position: fixedHeader ? "sticky" : "static",
              top: fixedHeader ? 0 : "auto",
              zIndex: fixedHeader ? 3 : "auto",
            }}
            sx={{
              "& .MuiTableCell-root": {
                textAlign: "left !important",
              },
            }}
          >
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  key={header.name || index}
                  variant="head"
                  align="left"
                  sx={{
                    ...HeaderRowClaimMIS,
                    ...header.style,
                    fontSize: "14px",
                    lineHeight: "20px",
                    textAlign: "left !important",
                    position: fixedHeader ? "sticky" : "static",
                    top: fixedHeader ? 0 : "auto",
                    zIndex: fixedHeader ? 4 : "auto",
                    backgroundClip: "padding-box",
                    whiteSpace: "nowrap",
                    padding: "28px 28px",
                  }}
                >
                  {header.display_name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}

        {/* --- DATA ROWS OR EMPTY SPACER --- */}
        {rows && rows.length === 0 ? (
          <TableBody>
            <TableRow>
              {/* Blank row that matches the full height of empty space */}
              <TableCell
                colSpan={headers?.length}
                sx={{
                  // height: "80px", // Height for empty state container space
                  border: 0,
                  padding: 0,
                }}
              />
            </TableRow>
          </TableBody>
        ) : null}

        {rows && rows.length > 0 && (
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={row.id || index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                {headers.map(({ name }, index) => (
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    key={name || index}
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: "16px 28px",
                      background: "white",
                    }}
                  >
                    <Ptag
                      style={{
                        display: "inline",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "rgba(0, 0, 0, 1)",
                      }}
                    >
                      {row[name] || "-"}
                    </Ptag>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>

      {/* --- SCREEN-VIEWPORT CENTERED NO DATA TEXT --- */}
      {rows && rows.length === 0 && (
        <Box
          sx={{
            position: "sticky",
            left: 0,
            right: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "24px 0",
            pointerEvents: "none", // Prevents blocking scrolling interactions
          }}
        >
          <span className="table-nodata-text-css">No Data Found</span>
        </Box>
      )}
    </TableContainer>
  );
}

export default ProTable;